import { ButtonType } from "../../../enums/ButtonAttributesEnums";

export const mockData = [
  {
    id: 1,
    jobName: 359,
    customerName: "Company",
    order: 'CEMEX - Blum Quarry - Commercial Base (1-3/4" minus)',
    truckNumber: "454",
    uploadedAt: "02/04/2025",
    archivedAt: "07/03/2025",
    singlePdfTicket:
      "public/tickets/33460781-df06-11ef-aee1-0bed8a39ff3f/rc-upload-1739864477384-15_TNBS_ticket_1",
  },
  {
    id: 2,
    jobName: 359,
    customerName: "Company",
    order: 'CEMEX - Blum Quarry - Commercial Base (1-3/4" minus)',
    truckNumber: "454",
    uploadedAt: "02/04/2025",
    archivedAt: "07/03/2025",
    singlePdfTicket:
      "public/tickets/33460781-df06-11ef-aee1-0bed8a39ff3f/rc-upload-1739864477384-15_TNBS_ticket_1",
  },
  {
    id: 3,
    jobName: 359,
    customerName: "Company",
    order: 'CEMEX - Blum Quarry - Commercial Base (1-3/4" minus)',
    truckNumber: "454",
    uploadedAt: "02/04/2025",
    archivedAt: "07/03/2025",
    singlePdfTicket:
      "public/tickets/33460781-df06-11ef-aee1-0bed8a39ff3f/rc-upload-1739864477384-15_TNBS_ticket_1",
  },
  {
    id: 4,
    jobName: 359,
    customerName: "Company",
    order: 'CEMEX - Blum Quarry - Commercial Base (1-3/4" minus)',
    truckNumber: "454",
    uploadedAt: "02/04/2025",
    archivedAt: "07/03/2025",
    singlePdfTicket:
      "public/tickets/33460781-df06-11ef-aee1-0bed8a39ff3f/rc-upload-1739864477384-15_TNBS_ticket_1",
  },
];

export const getArchivedTicketColumns = () => [
  {
    title: "Customer Name",
    sorter: false,
    width: "140px",
    key: "customerName",
    align: "center",
    dataIndex: "customerName",
    render: (customerName, record) => {
      return <span className="table-font-mobile">{customerName}</span>;
    },
  },
  {
    title: "Job Name",
    sorter: false,
    width: "140px",
    key: "jobName",
    align: "center",
    dataIndex: "jobName",
    render: (jobName, record) => {
      return <span className="table-font-mobile">{jobName} </span>;
    },
  },
  {
    title: "Order",
    sorter: false,
    width: "140px",
    key: "order",
    align: "center",
    dataIndex: "order",
    render: (order, record) => {
      return <span className="table-font-mobile">{order} </span>;
    },
  },

  {
    title: "Truck Number",
    sorter: false,
    width: "140px",
    key: "truckNumber",
    align: "center",
    dataIndex: "truckNumber",
    render: (truckNumber, record) => {
      return <span className="table-font-mobile">{truckNumber}</span>;
    },
  },
  {
    title: "Uploaded Date",
    sorter: false,
    width: "140px",
    key: "uploadedAt",
    align: "center",
    dataIndex: "uploadedAt",
    render: (uploadedAt, record) => {
      return <span className="table-font-mobile">{uploadedAt}</span>;
    },
  },
  {
    title: "Archived Date",
    sorter: false,
    width: "140px",
    key: "archivedAt",
    align: "center",
    dataIndex: "archivedAt",
    render: (archivedAt, record) => {
      return <span className="table-font-mobile">{archivedAt}</span>;
    },
  },
];

export const archivedTabButtonProps = {
  managerReview: {
    label: "Move to Manager Review",
    type: ButtonType.DEFAULT,
  },
  delete: {
    label: "Delete",
    type: ButtonType.PRIMARY,
  },
};

export const getDeleteModalProps = (fileCount?: number) => {
  return {
    title: "Delete files",
    content: `Are you sure you want to delete ${fileCount} ${
      fileCount > 1 ? "files" : "file"
    }?`,
    width: "746px",
    okButtonLabel: "Confirm",
    cancelButtonLabel: "Cancel",
    focusTriggerAfterClose: false,
  };
};

export const getManagerReviewModalProps = (fileCount?: number) => {
  return {
    title: "Move files to Manager Review",
    content: `Are you sure you want to move ${fileCount} ${
      fileCount > 1 ? "files" : "file"
    } to Manager Review?`,
    width: "746px",
    okButtonLabel: "Confirm",
    cancelButtonLabel: "Cancel",
    focusTriggerAfterClose: false,
  };
};

export const archivedTicketsActionMessages = (ticketCount?: number) => {
  return {
    reset: `${ticketCount} ${
      ticketCount > 1 ? "tickets are" : "ticket is"
    }  moved to Manager Review successfully`,
    delete: `${ticketCount} ${
      ticketCount > 1 ? "tickets" : "ticket"
    } deleted successfully`,
    resetError: "Failed to move tickets!",
    deleteError: "Failed to delete tickets!",
  };
};

export const fileViewerModalProps = {
  title: "Pdf Preview",
  width: "900px",
  footer: null,
  focusTriggerAfterClose: false,
};
